export default __webpack_public_path__ + "static/media/20.f07b4885.png";